import {
  Archive,
  CheckCircle2,
  CircleSlash,
  Clapperboard,
  Hourglass,
  Loader2,
  Radio,
  SignalHigh,
  TriangleAlert,
  Unplug,
  XCircle,
} from "lucide-react";

import type { LucideIcon } from "lucide-react";

import type { LiveState } from "../../utils/liveView";

type LiveTone = "neutral" | "warning" | "success" | "error" | "primary";

interface LiveStateStyle {
  tone: LiveTone;
  Icon: LucideIcon;
}

export const LIVE_STATE_STYLE: Record<LiveState, LiveStateStyle> = {
  blocked: { tone: "warning", Icon: TriangleAlert },
  ready: { tone: "neutral", Icon: Hourglass },
  scheduled: { tone: "neutral", Icon: Hourglass },
  provisioning: { tone: "warning", Icon: Loader2 },
  provisioningFailed: { tone: "error", Icon: XCircle },
  waitingSignal: { tone: "warning", Icon: Unplug },
  checkingSignal: { tone: "warning", Icon: Loader2 },
  readyToAir: { tone: "success", Icon: CheckCircle2 },
  publishing: { tone: "success", Icon: Loader2 },
  live: { tone: "success", Icon: Radio },
  degraded: { tone: "warning", Icon: SignalHigh },
  signalLost: { tone: "error", Icon: Unplug },
  stopping: { tone: "neutral", Icon: Loader2 },
  replayAvailable: { tone: "primary", Icon: Clapperboard },
  replayCreated: { tone: "primary", Icon: Clapperboard },
  replayUnavailable: { tone: "neutral", Icon: CircleSlash },
  ended: { tone: "neutral", Icon: CircleSlash },
};

export const ARCHIVED_STYLE: LiveStateStyle = {
  tone: "neutral",
  Icon: Archive,
};

export const TONE_ICON_CLASS: Record<LiveTone, string> = {
  neutral: "bg-muted text-muted-foreground",
  warning: "bg-status-warning/15 text-status-warning",
  success: "bg-status-active/15 text-status-active",
  error: "bg-status-error/15 text-status-error",
  primary: "bg-primary/10 text-primary",
};
